"use strict";
exports.__esModule = true;
var lodash_1 = require("lodash");
exports.getErrorMessage = function (empty, errorMessage) {
    if (empty) {
        return 'Required';
    }
    if (errorMessage) {
        return errorMessage;
    }
    return null;
};
exports.getAddCardError = function (error) {
    return lodash_1.get(error, 'graphQLErrors[0].extensions.response.body.stripe_token') ||
        'Please try again later or use another payment method.';
};
